// Node globals that webpack 4 shimmed implicitly. Some dependencies
// (@react-pdf/renderer v1, xlsx) reference Buffer/process at module scope,
// so this must be the first import in the entrypoint.
import { Buffer } from 'buffer';
import * as process from 'process';

const g = globalThis as any;
if (!g.Buffer) g.Buffer = Buffer;
if (!g.process) g.process = { env: {}, browser: true, ...process };
